export default "__VITE_ASSET__9fTlBfav__"